<template>
	<div id="fUser" v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 门禁报表</el-breadcrumb-item>
				<el-breadcrumb-item>门禁记录报表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container" v-if="power.search">
			<el-row>
				<el-col :span="5">
					<div class="handle-box">
						<el-input placeholder="单位名称" suffix-icon="el-icon-search" v-model.lazy="data.filterDeptStr"
							@change="filterDept" size="large" clearable>
							<el-checkbox slot="prepend" v-model="data.containSub"
								@change="changeContainSub">包含下级</el-checkbox>
						</el-input>
					</div>
					<div style="max-height:600px;overflow:auto;">
						<el-tree ref="depts" :data="data.depts" node-key="id" :check-on-click-node="true"
							highlight-current :expand-on-click-node="false" @node-click="handleDeptNodeClick"
							:filter-node-method="handleTreeFilter">
							<span class="span-ellipsis" slot-scope="{ node, data }">
								<span :title="node.label">{{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</el-col>
				<el-col :span="1">
					&nbsp;
				</el-col>
				<el-col :span="18">
					<div class="handle-box left">
						<el-date-picker v-model="data.daterange" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" size="large" class="mr10" style="width:500px" start-placeholder="开始时间" end-placeholder="结束时间" :clearable="false"></el-date-picker>
						<el-input class="mr10" v-model="data.filterstr" placeholder="人员编号/身份证/姓名/车牌号" size="large" style="width:305px;" clearable>
						</el-input>
						<el-select v-model="data.emptype" placeholder="人员/车辆类别" size="large" style="width:180px" class="mr10" clearable>
							<el-option :value="1" label="员工"></el-option>
							<el-option :value="2" label="保运"></el-option>
							<el-option :value="4" label="外协"></el-option>
							<el-option :value="8" label="访客卡"></el-option>
							<el-option :value="9" label="临时卡"></el-option>
							<el-option :value="100" label="长期车辆"></el-option>
							<el-option :value="101" label="临时车辆"></el-option>
						</el-select>
						<el-select v-model="data.eventtype" placeholder="事件类型" size="large" style="width:200px" class="mr10" clearable>
							<el-option :value="0" label="正常刷卡开门"></el-option>
							<el-option :value="75" label="人脸认证通过"></el-option>
							<el-option :value="10000" label="车牌识别+车卡认证通过"></el-option>
							<el-option :value="9999" label="车牌识别"></el-option>
							<el-option :value="27" label="人未登记"></el-option>
							<el-option :value="76" label="人脸认证失败"></el-option>
							<el-option :value="104" label="真人检测失败"></el-option>
							<el-option :value="9997" label="车牌号不存在"></el-option>
							<el-option :value="9998" label="车辆已过有效期"></el-option>
							<el-option :value="99999" label="其他事件"></el-option>
						</el-select>
						<el-button type="primary" icon="el-icon-search" size="small" @click="search">搜索</el-button>
						<el-button type="primary" icon="if-lcon-daoru" size="small" @click="exportExcel">导出</el-button>
					</div>
					<el-image-viewer v-if="visible.preview" :on-close="closeImagePreview" :url-list="data.imgs" />
					<el-table id="eventRecordTable" ref="table" :data="data.rows" border class="table" height="570">
						<el-table-column prop="img" label="图片" width="65" align="center">
							<template slot-scope="scope">
								<img src="../../assets/img/img.png" style="width:20px;cursor:pointer;" v-if="scope.row.eventImage" @click="previewEventImage(scope.row.eventImage.split(','))"></img>
							</template>
						</el-table-column>
						<el-table-column prop="empType" label="人员类别" width="120">
							<template slot-scope="scope">
								<el-tag type="info" v-if="scope.row.empType == 1">员工</el-tag>
								<el-tag type="info" v-else-if="scope.row.empType == 2">保运</el-tag>
								<el-tag type="info" v-else-if="scope.row.empType == 4">外协</el-tag>
								<el-tag type="info" v-else-if="scope.row.empType == 8">访客卡</el-tag>
								<el-tag type="info" v-else-if="scope.row.empType == 9">临时卡</el-tag>
								<el-tag type="info" v-else-if="scope.row.empType == 100">长期车辆</el-tag>
								<el-tag type="info" v-else-if="scope.row.empType == 101">临时车辆</el-tag>
								<el-tag type="info" v-else>-</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="code" :label="(data.emptype >= 100 ? '车辆' : '人员')+'编号'" width="140">
						</el-table-column>
						<el-table-column prop="deptName" label="部门/单位" width="200" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="idno" label="身份证" width="230">
						</el-table-column>
						<el-table-column prop="empName" label="姓名/车牌号" width="130">
						</el-table-column>
						<el-table-column prop="eventTypeName" label="事件类型" width="150" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="eventTime" label="事件时间" width="210">
						</el-table-column>
						<el-table-column prop="areaName" label="区域" width="100" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="doorName" label="授权点" width="200" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="inOut" label="进出" width="70">
							<template slot-scope="scope">
								<el-tag type="info" v-if="scope.row.inOut == 0">进</el-tag>
								<el-tag type="info" v-else-if="scope.row.inOut == 1">出</el-tag>
								<el-tag type="info" v-else>-</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="success" label="是否成功" width="120">
						</el-table-column>
						<el-table-column prop="temperature" label="体温" width="80">
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
							:current-page="data.page" :page-sizes="[10,14,20,50,100,200,300,400,500]"
							:page-size="data.size" layout="total, sizes, prev, pager, next, jumper" :total="data.total">
						</el-pagination>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	import printJS from 'print-js';
	export default {
		name: 'eventrecord',
		components: { ElImageViewer },
		data() {
			return {
				data: {
					filterstr: '',
					daterange: [],
					emptype: '',
					eventtype: '',
					total: 0,
					size: 14,
					page: 1,
					rows: [],
					filterDeptStr: '',
					containSub: true,
					depts: [],
					curDeptId: 0,
					imgs: []
				},
				visible: {
					print: false,
					preview: false,
					loading: false
				},
				power: {
					pageId: 76,
					search: false,
					export: false,
					print: false
				}
			}
		},
		methods: {
			previewEventImage(imgs) {
				this.data.imgs = [];
				for (let i = 0; i < imgs.length; i++) {
					this.data.imgs.push('/im/' + imgs[i]);
				}
				this.visible.preview = true;
			},
			closeImagePreview() {
				this.data.imgs = [];
				this.visible.preview = false;
			},
			search(change) {
				let ths = this;
				ths.visible.loading = true;
				if (change) {
					ths.data.page = 1;
				}
				let query = '?sign=' + window.$gloable.userinfo.sign + '&starttime=' + ths.data.daterange[0] + '&endtime=' + ths.data.daterange[1] + '&emptype=' + ths.data.emptype + '&eventtype=' + ths.data.eventtype + '&deptid=' + ths.data.curDeptId + '&containdown=' + (ths.data.containSub ? 1 : 0) + '&pagesize=' + ths.data.size + '&currentpage=' + ths.data.page + '&filterstr=' + ths.data.filterstr;
				window.ax.get('api/report/acs/eventrecordlist' + query, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						ths.data.rows = data.datas;
						ths.data.total = total;
						if (len == 0 && total > 0) {
							ths.data.page = Math.ceil(total / ths.data.size);
							ths.search();
						}
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			exportExcel() {
				let ths = this;
				let query = '?sign=' + window.$gloable.userinfo.sign + '&starttime=' + ths.data.daterange[0] + '&endtime=' + ths.data.daterange[1] + '&emptype=' + ths.data.emptype + '&eventtype=' + ths.data.eventtype + '&deptid=' + ths.data.curDeptId + '&containdown=' + (ths.data.containSub ? 1 : 0) + '&filterstr=' + ths.data.filterstr;
				window.open('api/report/acs/exporteventrecord' + query, '_blank');
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.data.page = 1;
				this.search();
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			changeContainSub() {
				this.search(true);
			},
			filterDept() {
				this.data.filterDeptStr = this.data.filterDeptStr.toLowerCase();
				this.$refs.depts.filter(this.data.filterDeptStr);
			},
			handleDeptNodeClick(data, node, target) {
				let ths = this;
				if (ths.data.curDeptId != data.id) {
					ths.data.curDeptId = data.id;
					ths.data.filterstr = '';
					ths.search(true);
				}
			},
			handleTreeFilter(value, data, node) {
				if (!value) {
					return true;
				} else {
					return data.label && data.label.toLowerCase().indexOf(value) != -1;
				}
			},
			toExport() {
			},
			toPrint() {
			}
		},
		created() {
			let ths = this;
			let begin = new Date();
			let end = new Date();
			end.setMonth(end.getMonth() + 1);
			end = new Date(new Date(end.toDateFormatString('yyyy-MM-01 00:00:00')) - 1000);
			ths.data.daterange = [
				begin.toDateFormatString('yyyy-MM-01 00:00:00'),
				end.toDateFormatString('yyyy-MM-dd 23:59:59')
			];
			ths.baseJS.initPower(ths.power);
			ths.api.loadDepartmentTree(ths, 'data.depts', 'visible.loading');
			ths.search();
		},
		mounted() {}
	}
</script>

<style>
	.is-current {
		background: #cccccc;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.m10 {
		margin: 10px;
	}

	.mt1 {
		margin-top: 1px;
	}

	.fr {
		float: right;
	}

	.form-warp {
		position: relative;
		width: 560px;
		height: 520px;
		padding-left: 200px;
		border: 1px solid #ccc;
	}

	.form-warp-left {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 492px;
		padding-top: 28px
	}

	.department-search {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	.department-tree {
		position: relative;
		height: 490px;
		width: 100%;
		border-right: 1px solid #ddd
	}

	.form-warp-main {
		position: relative;
		height: 492px;
		width: 100%;
		padding-top: 28px
	}

	.employee-search {
		position: absolute;
		top: 0;
		left: 1px;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd
	}

	.list {
		position: relative;
		height: 492px;
		width: 560px
	}

	.card-box {
		position: relative;
		float: left;
		width: 100px;
		height: 60px;
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 3px;
		margin: 10px 0 0 10px;
		padding-left: 69px;
		overflow: hidden;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		cursor: pointer
	}

	.card-box.active {
		border: 1px solid #ff5d5b;
		background: url(../../assets/img/selected_red.png) right top no-repeat
	}

	.card-box-img {
		position: absolute;
		left: 0;
		top: 0;
		width: 56px;
		height: 60px;
		line-height: 60px;
		padding-left: 5px;
		background-color: #ebebeb;
		border-right: 1px solid #ccc
	}

	.card-box-img img {
		border-radius: 45px;
		width: 50px;
		height: 50px;
		margin-top: 5px;
	}

	.card-box-content {
		padding: 6px 0
	}

	.card-box-content p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0;
		font-size: 10px
	}

	.form-warp-right {
		position: absolute;
		top: 0;
		right: 0;
		height: 492px;
		width: 180px;
		border-left: 1px solid #ddd;
		padding-top: 28px;
		background-color: #fff;
		z-index: 10;
		transition: all 300ms;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.form-warp-right.hide {
		width: 0px;
	}

	.form-warp-right-close {
		position: absolute;
		top: 7px;
		right: 4px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer
	}

	.form-warp-right-close:hover {
		background-position: 0 -12px
	}

	.form-warp-right-title {
		position: absolute;
		top: 0;
		right: 0;
		height: 28px;
		line-height: 27px;
		padding-left: 10px;
		width: 170px;
		border-bottom: 1px solid #ddd;
		cursor: pointer
	}

	.selected-list-warp {
		position: relative;
		height: 492px;
		width: 180px;
	}

	.selected-box {
		position: relative;
		width: 150px;
		height: 55px;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin: auto;
		margin-top: 10px;
		padding: 5px 0 0 10px
	}

	.selected-box p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0
	}

	.remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer;
		opacity: 0.5
	}

	.remove:hover {
		opacity: 1
	}

	.selected-btn {
		position: absolute;
		top: 0;
		right: 1px;
		height: 100%;
		width: 80px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.selected-btn:hover {
		color: #333
	}

	.form-control {
		border: 0;
		height: 100%;
	}

	.input-query {
		position: absolute;
		right: 146px;
		top: 5px;
		color: #ccc;
		font-size: 16px;
		cursor: pointer
	}

	.select-all {
		position: absolute;
		top: 0;
		right: 80px;
		height: 100%;
		width: 60px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.span-ellipsis {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
	}

	.el-tree-node__content {
		height: 36px !important;
	}
</style>
